// extracted by mini-css-extract-plugin
export default {"summaryContainer":"PatientSummary_summaryContainer__RaIT1"};